import styled from "styled-components";
import theme from "../../../theme";

const Container = styled.div`
  min-height: 100vh;
  background: ${theme.colors.primary};

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const Circle = styled.div`
  position: relative;
  width: 600px;
  height: 600px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CenterText = styled.div`
  text-align: center;
  color: white;
  position: absolute;
  width: 200px;

  h1 {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
    line-height: 1.2;
  }
`;

const Feature = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transform: translate(-50%, -50%);
  left: ${(props) => props.x}px;
  top: ${(props) => props.y}px;
`;

const IconWrapper = styled.div`
  background: white;
  border-radius: 30%;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Label = styled.div`
  background: white;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  color: black;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
`;

const SC = {
  Container,
  Circle,
  CenterText,
  Feature,
  IconWrapper,
  Label,
};

export default SC;
